import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { bool, func, shape, string } from "prop-types";
import { push } from "react-router-redux";

import { selectors as recoveryPasswordSelectors } from "reducers/recoveryPassword";
import { actions as loginActions } from "reducers/login";
import Step2Content from "pages/recoveryPassword/_components/Step2Content";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import withExchangeToken from "pages/_components/withExchangeToken";
import GridLayoutExternal from "pages/_layouts/GridLayoutExternal";
import I18n from "pages/_components/I18n";
import Logo from "pages/login/_components/Logo";
import Container from "pages/_components/Container";
import { Col } from "react-bootstrap";

class RecoveryUserpassStep2 extends Component {
    componentDidMount() {
        const { dispatch, userName } = this.props;
        if (!userName) {
            dispatch(push("/"));
        }
    }

    onHeaderClose = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
    };

    renderTitleMobile = () => (
        <div className="w-min-content">
            <Logo className="svg-image logo logo-mobile-size" logoColor />
        </div>
    );

    render() {
        const { isDesktop, isRecoveringUserpass, propsGrid } = this.props;

        return (
            <GridLayoutExternal scopeToShow="recoveryPassword" isDesktop={isDesktop} {...propsGrid}>
                <Container>
                    <Col xs="12" className={isDesktop ? "px-0" : ""}>
                        <Head
                            onClose={this.onHeaderClose}
                            title={isDesktop ? "recoveryPassword.step2.header" : null}
                            headerClassName={!isDesktop ? "login-background-color-white" : "recover-pass-desktop"}
                            centerElement={!isDesktop && this.renderTitleMobile}
                            hideMobileMenu={!isDesktop && true}
                            fixed
                        />
                    </Col>
                </Container>
                <MainContainer
                    className={classNames("login__layout main-container", {
                        "container-fluid": isDesktop,
                    })}>
                    {!isDesktop && (
                        <Container className="container--layout flex-grow">
                            <Col className="col col-12 view-title mt-3">
                                <div className="justify-content-center">
                                    <I18n
                                        id="recoveryPassword.step2.header"
                                        componentProps={{ className: "f-size-5 font-regular" }}
                                        component="h2"
                                    />
                                </div>
                            </Col>
                        </Container>
                    )}
                    <Step2Content {...this.props} isRecoveringUserpass={isRecoveringUserpass} />
                </MainContainer>
            </GridLayoutExternal>
        );
    }
}

RecoveryUserpassStep2.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool,
    isRecoveringUserpass: bool,
    propsGrid: shape({}).isRequired,
    userName: string.isRequired,
};

RecoveryUserpassStep2.defaultProps = {
    isDesktop: true,
    isRecoveringUserpass: true,
};

const mapStateToProps = (state) => ({
    isRecoveryPassAndUserpass: recoveryPasswordSelectors.getRecoveryPassAndUserpass(state),
    userName: recoveryPasswordSelectors.getUserName(state),
});

export default connect(mapStateToProps)(withExchangeToken(RecoveryUserpassStep2));
